export default "__VITE_ASSET__4fc707a5__"